var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content',[_c('transacions',{attrs:{"changeStatus":_vm.changeStatus}}),(_vm.status == 'loading')?_c('Empty'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }